import Tenant from "./tenant";
import { WhatsAppContainer } from "./whatsapp-container";


export type IncomingWhatsAppPod = {
    connectionId: string;
    podName: string;
    niboWAHAContainer?: WhatsAppContainer;
    wahaContainer?: WhatsAppContainer;
    labels: { [key: string]: string };
    tenant: Tenant;
}

export default class WhatsAppPod {
    readonly connectionId: string;
    readonly podName: string;
    readonly labels: { [key: string]: string };
    readonly tenant: Tenant;
    readonly niboWAHAContainer?: WhatsAppContainer;
    readonly wahaContainer?: WhatsAppContainer;

    constructor(data: IncomingWhatsAppPod) {
        this.connectionId = data.connectionId;
        this.podName = data.podName;
        this.niboWAHAContainer = data.niboWAHAContainer;
        this.wahaContainer = data.wahaContainer;
        this.labels = data.labels;
        this.tenant = data.tenant;
    }
}